export const STYLES = {
  primaryButton:
    'font-medium rounded-3xl transition-colors duration-200 bg-[var(--lifexlight)] text-white hover:bg-[var(--lifexDark)] w-full text-md',
  outlineButton:
    'font-medium rounded-3xl transition-colors duration-200 bg-white border border-[var(--lifexlight)] text-[var(--lifexlight)] hover:bg-[var(--lifexlight)] hover:text-white w-full text-md',
  linkButton: '',
  dangerButton:
    'font-medium rounded-3xl transition-colors duration-200 bg-red-500 text-white w-full text-md hover:bg-red-600',
  smallButton: 'px-2 py-1 text-sm',
  mediumButton: 'px-4 py-2',
  largeButton: 'px-6 py-3 text-lg',
  disabledButton: 'opacity-50 cursor-not-allowed',
};
